import React from 'react';
import { Box, Typography } from '@mui/material';
import { getTeamMark } from '../data/teamDirectory';

/**
 * Team badge in the style of the Bettor Advantage demo: the team's
 * abbreviation on its primary color, with a border and an inset bottom
 * stripe in its secondary color. Replaces photographic logo images.
 */
const TeamBadge = ({ teamName, size = 35, sx }) => {
  const mark = getTeamMark(teamName);
  const fontSize =
    size * (mark.abbr.length >= 4 ? 0.3 : mark.abbr.length === 3 ? 0.36 : 0.44);

  return (
    <Box
      role="img"
      aria-label={teamName}
      title={teamName}
      sx={{
        width: size,
        height: size,
        borderRadius: '9px 2px 9px 2px',
        backgroundColor: mark.primary,
        border: `1px solid ${mark.secondary}`,
        boxShadow: `inset 0 -4px 0 ${mark.secondary}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        ...sx,
      }}
    >
      <Typography
        component="span"
        sx={{
          color: '#ffffff',
          fontWeight: 800,
          fontSize,
          lineHeight: 1,
          letterSpacing: '0.02em',
          userSelect: 'none',
        }}
      >
        {mark.abbr}
      </Typography>
    </Box>
  );
};

export default TeamBadge;
